export default {
  title: "Výběr hry",
  forNewbies: "Pro nováčky",
  forExperts: "Pro náročné",
};
